import { render, staticRenderFns } from "./TaskInfoCard.vue?vue&type=template&id=7ae6b5da&scoped=true"
import script from "./TaskInfoCard.vue?vue&type=script&lang=js"
export * from "./TaskInfoCard.vue?vue&type=script&lang=js"
import style0 from "./TaskInfoCard.vue?vue&type=style&index=0&id=7ae6b5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae6b5da",
  null
  
)

export default component.exports